/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_LanguageInputs */

const en_us2_profile_language = /** @type {(inputs: Profile_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const pt_br2_profile_language = /** @type {(inputs: Profile_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const es_419_profile_language = /** @type {(inputs: Profile_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const pt_pt2_profile_language = /** @type {(inputs: Profile_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const fr_fr2_profile_language = /** @type {(inputs: Profile_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const de_de2_profile_language = /** @type {(inputs: Profile_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const it_it2_profile_language = /** @type {(inputs: Profile_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Profile_LanguageInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_language = /** @type {((inputs?: Profile_LanguageInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_LanguageInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_language(inputs)
	if (locale === "es-419") return es_419_profile_language(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_language(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_language(inputs)
	if (locale === "de-DE") return de_de2_profile_language(inputs)
	if (locale === "it-IT") return it_it2_profile_language(inputs)
	return en_us2_profile_language(inputs)
});
export { profile_language as "profile.language" }